<template lang="pug">
v-layout
    //-v-app-bar.custom-toolbar.no-padding(color='white' height="60" absolute style="z-index:10;background: radial-gradient(circle, rgba(246,206,0,1) 0%, rgba(215,166,0,1) 100%);")
    //-v-app-bar.custom-toolbar.no-padding(color='white' height="60" absolute style="z-index:10;background: rgb(99,198,251);background: radial-gradient(circle, rgba(254,255,221,1) 0%, rgba(255,231,143,1) 100%);" v-if="notification")
        v-icon.pl-5 fas fa-exclamation-triangle
        //-p.pa-0.ma-0.ml-2(style="font-weight:bold;font-size:17px;line-height:18px;width:100%;color:rgba(0,0,0,0.8);").text-center AVISO: Por cambio de IP's públicas de los dominios del Ministerio de Educación, los sistemas de la UGPSEP <br>no estarán disponibles desde las 20:00 del 31 de marzo, hasta las 08:00 del 1 de abril
        p.pa-0.ma-0.ml-2(style="font-weight:bold;font-size:17px;line-height:18px;width:100%;color:rgba(0,0,0,0.8);").text-center AVISO: Por razones administrativas, los sistemas de la UGPSEP <br>no estarán disponibles desde las 20:00 del 31 de marzo, hasta las 08:00 del 1 de abril
        v-spacer
        v-btn(icon fab @click="notification=false").mr-2
            v-icon fas fa-times
    v-app-bar.custom-toolbar.no-padding(color='white' height="60" absolute style="z-index:10;background: rgb(99,198,251);background: radial-gradient(circle, rgba(254,255,221,1) 0%, rgba(255,231,143,1) 100%);" v-if="alerta")
        v-icon.pl-5 fas fa-exclamation-triangle
        //-p.pa-0.ma-0.ml-2(style="font-weight:bold;font-size:17px;line-height:18px;width:100%;color:rgba(0,0,0,0.8);").text-center AVISO: Por cambio de IP's públicas de los dominios del Ministerio de Educación, los sistemas de la UGPSEP <br>no estarán disponibles desde las 20:00 del 31 de marzo, hasta las 08:00 del 1 de abril
        p.pa-0.ma-0.ml-2(style="font-weight:bold;font-size:17px;line-height:18px;width:100%;color:rgba(0,0,0,0.8);" v-html="mensaje").text-center
        v-spacer
        v-btn(icon fab @click="alerta=false").mr-2
            v-icon fas fa-times
    v-app-bar.custom-toolbar.no-padding(color='white' app height="70" :style="alerta?'margin-top:60px':''")
        //-TEMP a.custom-logo.no-margin.no-padding(@click="goToHome" v-show="showLogo")
        //-v-btn(v-if="$store.state.loadingTabs" color="blue darken-4" fab text dark loading style="padding:0px;margin:0px;")
        v-custom-tabs-pulp(v-if="$can(['rol.pulperia'])" :callback="changeIframeBy" ref="customTabs")
        v-custom-tabs(v-else :callback="changeIframeBy" ref="customTabs")
        v-spacer
        v-idle.pa-0.ma-0.mr-4.subtitle-2.red--text(:events="[]" :duration="3600" :key="keyRerender" :reminders="[600]" @remind="showIdleTimer = true" @idle="endSession" :loop="false" v-show="false")
        v-divider(vertical)
        //-v-btn.txtn(v-if="!styleDocuments" style="border-bottom:#960407 solid 3px;" @click="changeIframeByAndSetTab('/ui/ui-mis-documentos')" text large height="70").rounded-0
        v-btn.txtn(style="overflow:hidden;" :class="{ 'tab-active' : $store.state.tabDocument == true }" v-if="!styleDocuments && !$can(['manager.menu.cns','manager.menu.despacho','rol.pulperia'])" @click="changeIframeByAndSetTab('/ui/ui-mis-documentos')" text large height="70").rounded-0.tab-inactive
            v-icon(color="#960407") far fa-folder-open
            | &nbsp;Mis Documentos
            div(v-show="$store.state.tabDocument" style="width:130%;height:10px;position:absolute;bottom:-31px;right:-22px;").primary
        v-btn(v-else-if="!$can(['manager.menu.cns','manager.menu.despacho','rol.pulperia'])" large text style="width:60px;min-width:50px;height:62px" @click="changeIframeByAndSetTab('/ui/ui-mis-documentos')").mr-1.ml-1
            v-icon(color="#960407") far fa-folder-open
        v-divider(vertical)
        v-user-options
        template(v-slot:extension v-if="showIdleTimer" transition="scale-transition")
            v-sheet(style="width:100%;").text-center
                v-app-bar(color="red" height="48px")
                    v-spacer
                    v-icon.mr-4 fas fa-exclamation-triangle
                    p.pa-0.ma-0.mr-1.subtitle-2.white--text Su sesión terminará en:
                    v-idle.pa-0.ma-0.mr-4.subtitle-2.white--text(:events="[]" :duration="600" :key="keyRerender" :loop="false")
                    v-btn(outlined color="white" @click="extendSession").txtn Extender sesión
                    v-spacer
                //-v-alert(color="red" dense type="success" width="100%" height="40px") Su sessión terminará en: 1:10 
    v-main(style="height:100%;overflow:hidden")
        iframe(:src="mySrc" frameborder="0" width="100%" height="100%" hspace="0" vspace="0" marginheight="0"  :style="alerta?'margin:0px;padding:0px;padding-top:60px;':'margin:0px;padding:0px;'")
    //-v-sheet(v-if="!alertVersion" style="background:rgba(0,0,0,0);width:100%;position:fixed;bottom:15px;left:0px;pointer-events:none;z-index:9999999")
        v-alert(prominent type="info" color="blue darken-2" style="width:auto;max-width:456px;margin:0px auto;pointer-events:initial").pa-0.pl-5.rounded-lg
            v-card.transparent(flat)
                v-card-text.pa-3.pl-1.pb-0
                    h4.pb-1(style="font-size:16px;") Nueva versión del sistema disponible!
                    p(style="line-height:18px !important;").pa-0.ma-0 Está manejando una versión anterior del sistema, debe actualizar la página para cargar el nuevo contenido.
                v-card-actions.pt-2
                    v-btn.txt-normal(outlined color="white" @click="alertVersion = false" small) Cerrar
                    v-spacer
                    v-btn.txt-normal(color="success" @click="reloadPage").font-weight-bold Actualizar
        //-v-alert(prominent type="info" style="position:absolute;max-width:440px;bottom:0px;right:25%;left:50%;margin-left:-220px;").pa-0.pl-5
            v-card.transparent(flat)
                v-card-text.pa-3.pl-1.pb-0
                    span Nuevo contenido disponible,<br>Haga click en Actualizar para actualizar.
                v-card-actions
                    v-spacer
                    v-btn.blue.darken-2 Actualizar
        //-v-row(align="center")
            v-col.grow
                | Nuevo contenido disponible,<br>Haga click en Actualizar para actualizar.
        //-v-row(align="right")
            v-btn Actualizar
    v-dialog(v-model="dialogVersion" persistent overlay-opacity=0.8 overlay-color="#025" max-width="500" style="z-index:99999999 !important;")
        v-card(style="border-radius:10px;")
            v-card-text.pa-0.pb-4.pt-4
                h3.text-center.blue--text.font-weight-regular(style="max-width:400px;font-size:20px;line-height:24px;").center Nueva versión del sistema disponible!
            v-divider
            v-card-text.pa-0.pt-5.pb-3
                h3.text-center.blue-grey--text.text--darken-2.font-weight-regular(style="max-width:400px;font-size:16px;line-height:20px;").center Está manejando una versión anterior del sistema,<br>debe actualizar la página para cargar el nuevo contenido.
            v-card-actions
                v-spacer
                v-btn(large color="success" style="border-radius:10px;" @click="reloadPage").pl-6.pr-6.txtn Actualizar
                v-spacer
    v-dialog(v-model="isIdle" fullscreen persistent)
        v-card(color="rgba(0,20,50,0.7)" style="border-radius:0px;backdrop-filter: blur(3px);height:100%")
            v-card-text(style="height:100%;")
                v-container(bg fill-height grid-list-md text-xs-center)
                    v-layout(row wrap align-center)
                        v-flex
                            v-card(max-width="350" style="margin:0px auto;"  color="rgba(255,255,255,0.5)")
                                v-card-text.text-center(style="background-color:rgba(255,255,255,0.5)")
                                    v-icon(color="red darken-2" size="40").mt-2 fas fa-exclamation-triangle
                                v-card-text.text-center.pt-0.pb-3(style="background-color:rgba(255,255,255,0.5)")
                                    p.ma-0.pa-0.black--text.subtitle-2 Su sesión ha expirado<br>Inicie sesión para continuar
                                v-divider
                                v-card-actions
                                    v-spacer
                                    v-btn.txtn(color="blue darken-3" dark href="/portada").pl-3.pr-3 Iniciar sesión
                                    v-spacer
    v-dialog(v-model="$store.state.changePasswordDialog" persistent max-width="420px" overlay-opacity="0.6" overlay-color="#000")
        v-card(style="border-radius:10px;")
            v-card-text.pa-4.pb-2.text-center
                v-img(src="/img/shield.png" max-width="100px").center.mt-5
            v-card-text.pa-4.pb-3
                h3.text-center.blue--text.font-weight-regular(style="max-width:400px;font-size:20px;line-height:24px;").center Queremos asegurarnos<br>de que tu cuenta esté protegida.
                //-div(style="width:100%;height:1px;background-color:rgba(0,0,0,0.2)").mt-2.mb-2
                password(v-model="newPass" :strength-meter-only="true" @score="level")
                h3.text-center.blue-grey--text.text--darken-2.font-weight-regular(style="max-width:400px;font-size:16px;line-height:20px;margin-top:-10px !important;").center Por favor, cambia tu contraseña<br> por una distinta a tu fecha de nacimiento:
            v-card-text.pa-4.pb-0
                v-text-field(@keyup="changeInput" @keydown.tab.prevent="nextPass" label="Nueva contraseña:" v-model="newPass" :append-icon="showNewPass ? 'fas fa-eye' : 'fas fa-eye-slash'" :type="showNewPass ? 'password' : 'text'" @click:append="changeNewPass" ref="refNewPass" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.required, rules.min]").center
                v-text-field(@change="changeInput" @keydown.tab.prevent="nextRepeatPass" label="Repetir nueva contraseña:" v-model="repeatNewPass" :append-icon="showRepeatNewPass ? 'fas fa-eye' : 'fas fa-eye-slash'" :type="showRepeatNewPass ? 'password' : 'text'" @click:append="changeRepeatNewPass" ref="refRepeatNewPass" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.required, rules.min]").center
            v-card-actions.pt-0.pb-4
                h4(style="font-size:12px;" v-show="showLevel").font-weight-regular Tipo de contraseña: &nbsp;<br><span :style="styleNivelText">{{ nivelText }}</span>
                //-h4(:style="styleNivelText" v-show="showLevel").font-weight-regular {{ nivelText }}
                v-spacer
                v-btn(color="success" style="border-radius:10px;" @click="verifyPassword" :loading="loaderBtnSavePassword" ref="refBtnSave").pl-4.pr-4 Guardar
    v-dialog(v-model="confirmationDialog" max-width="420px")
        v-card(style="border-radius:10px;")
            v-card-text.pa-4.pb-2.text-center
                v-img(src="https://sisep.minedu.gob.bo/img/shield-success.png" max-width="100px").center.mt-5
            v-card-text.pa-4.pb-5
                h3.text-center.green--text.font-weight-regular(style="max-width:400px;font-size:20px;line-height:24px;").center Información guardada<br>correctamente !
                div(style="width:100%;height:1px;background-color:rgba(0,0,0,0.2)").mt-2.mb-2
                h3.text-center.blue-grey--text.text--darken-2.font-weight-regular(style="max-width:400px;font-size:16px;line-height:20px;").center.mt-1 ¡Gracias por tu colaboración<br>en mantener tu cuenta segura!
            v-card-actions.pb-4
                v-spacer
                v-btn(large color="success" style="border-radius:10px;" @click="confirmationDialog=false").pl-6.pr-6 Aceptar
                v-spacer
    v-dialog(v-model="$store.state.checkFourMonthPassword" persistent max-width="660" overlay-opcacity="0.6" overlay-color="#000")
        v-card(style="border-radius:10px;")
            v-card-text.pa-0.text-center
                v-flex(style="width:400px;display:flex").center.pt-4.pb-4
                    v-img(src="https://sisep.minedu.gob.bo/img/shield.png" max-width="100px" style="width:100px;")
                    v-flex(style="flex:1;")
                        h3.text-left.ml-4.mt-2.mb-1.font-weight-bold(style="max-width:400px;font-size:19px;line-height:23px;color:#2196F3;")
                            | Queremos asegurarnos<br>de que tu cuenta esté protegida
                        h3.text-left.ml-4.font-weight-medium(style="max-width:400px;font-size:16px;line-height:19px;color:#515151;")
                            | Complete el siguiente formulario<br>antes de continuar:
                div(style="width:100%;height:3px;background-color:rgba(0,0,0,0.2)").mb-5
            v-card-text.pa-0
                v-container
                    v-form(v-model="validForm" ref="refValidForm" lazy-validation)
                        v-row
                            v-col(cols="12" sm="6" style="border-right:#C5C5C5 3px solid !important;").pa-0.pl-5.pr-5
                                h4.text-center.font-weight-medium.mb-5(style="line-height:18px;") No ha cambiado su contraseña<br> en los últimos 4 meses:
                                v-text-field(label="Nueva contraseña:" @keydown.tab.prevent="nextFormPass" v-model="valuesForm.newPass" :append-icon="showNewFormPass ? 'fas fa-eye' : 'fas fa-eye-slash'" :type="showNewFormPass ? 'password' : 'text'" @click:append="changeNewFormPass" ref="refNewFormPass" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.required, rules.min]").center
                                //-h5.pl-4.pr-4.mb-5.text-right(:style="styleNivelText") {{ nivelText }}
                                v-text-field(label="Repetir nueva contraseña:" @keydown.tab.prevent="nextRepeatFormPass" v-model="valuesForm.repeatNewPass" :append-icon="showRepeatNewFormPass ? 'fas fa-eye' : 'fas fa-eye-slash'" :type="showRepeatNewFormPass ? 'password' : 'text'" @click:append="changeRepeatNewFormPass" ref="refRepeatNewFormPass" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.required, rules.min]").center
                                password(v-model="valuesForm.newPass" :strength-meter-only="true" :toggle="true" @score="level").pl-3.pr-3.pt-2
                            v-col(cols="12" sm="6").pa-0.pl-5.pr-5
                                h4.text-center.font-weight-medium.mb-5(style="line-height:18px;") Se solicita que registre<br> la siguiente información adicional:
                                v-file-input.custom-avatar(:label="fotoLabel" prepend-icon="fas fa-camera" v-model="valuesForm.photo" ref="refPhoto" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.photo]" accept="image/png, image/jpeg").center
                                v-text-field(label="Correo electrónico:" @keydown.tab.prevent="nextRepeatFormEmail" v-model="valuesForm.email" prepend-icon="fas fa-at" ref="refEmail" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.required, rules.min, rules.email]").center
                                v-text-field(label="Numero de celular:" @keydown.tab.prevent="nextRepeatFormPhone" @keydown.enter="saveUserInfo" v-model="valuesForm.phone" prepend-icon="fas fa-phone" ref="refPhone" color="blue" outlined dense style="max-width:330px;border-radius:10px;" :rules="[rules.required, rules.min, rules.phone]").center
                div(style="width:100%;height:3px;background-color:rgba(0,0,0,0.2)").mt-5.mb-1
            v-card-actions.pb-3.pr-2
                v-spacer
                v-btn(color="success" rounded style="border-radius:28px;" @click="saveUserInfo" :loading="btnSaveUserInfoLoading" ref="refBtnSaveInfo").pl-7.pr-7.txtn Guardar
</template>

<style lang="stylus">
.tab-inactive
    border-bottom rgba(0,0,0,0) solid 0px
.custom-avatarr .v-input__prepend-outerr
    margin-right 3px
.tab-active
    border-bottom #960407 solid 0px
</style>

<script>
import Password from 'vue-password-strength-meter'
export default {
    components: { Password },
    data: () => ({
        dialogVersion: false,
        validForm: false,
        fotoLabel: 'Foto (opcional):',
        name: process.env.VUE_APP_ENVIRONMENT,
        showNewPass: true,
        showNewFormPass: true,
        showLevel: false,
        showRepeatNewPass: true,
        showRepeatNewFormPass: true,
        mySrc: '/home',
        currentTab: 0,
        alertVersion: false,
        version: null,
        showIdleTimer: false,
        keyRerender: 0,
        isIdle: false,
        alerta: false,
        mensaje: '',
        nivelText: '',
        loaderBtnSavePassword: false,
        newPass: '',
        repeatNewPass: '',
        confirmationDialog: false,
        btnSaveUserInfoLoading: false,
        styleNivelText: 'font-size:12px;margin-top:-25px;',
        valuesForm: {
            newPass: '',
            repeatNewPass: '',
            photo: null,
            email: '',
            phone: ''
        },
        rules:{
            required: value => !!value || 'Este campo es requerido.',
            min: value => value.length >= 6 || 'Se requiere almenos 6 letras.',
            email: value => {
                const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
                return pattern.test(value) || 'Correo electrónico inválido.'
            },
            phone: value => {
                const pattern = /^[+\-]?[0-9\s]{5,13}$/;
                return pattern.test(value) || 'Número de celular inválido.'
            },
            photo: value => !value || value.size < 2000000 || 'La imagen debe ser menor a 2MB.'
        }
    }),
    computed:{
        showLogo(){
            if(this.$store.state.windowSize.w>550){
                return true;
            }
            else{
                return false;
            }
        },
        styleDocuments(){
            if(this.$store.state.windowSize.w<1100){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods:{
        level(event){
            if(event != null){
                if(event == 0){this.nivelText='Contraseña: Vulnerable';this.styleNivelText="font-size:12px;margin-top:-25px;color:darkred"}
                else if(event == 1){this.nivelText='Contraseña: Insegura';this.styleNivelText="font-size:12px;margin-top:-25px;color:#ff4500"}
                else if(event == 2){this.nivelText='Contraseña: Segura';this.styleNivelText="font-size:12px;margin-top:-25px;color:orange"}
                else if(event == 3){this.nivelText='Contraseña: Fuerte';this.styleNivelText="font-size:12px;margin-top:-25px;color:#81b90e"}
                else if(event == 4){this.nivelText='Contraseña: Altemente Segura';this.styleNivelText="font-size:12px;margin-top:-25px;color:green"}
                else{this.nivelText='';this.styleNivelText="font-size:12px;margin-top:-25px;"}
            }
        },
        saveUserInfo(){
            if(this.$refs.refValidForm.validate()){
                if(this.valuesForm.newPass == this.valuesForm.repeatNewPass){
                    this.btnSaveUserInfoLoading = true;
                    this.sendDataUser();
                }
                else{
                    this.$snotify.error("Las contraseñas deben coincidir.",{timeout:8000});
                }
            }
            else{
                this.$snotify.error("Complete los campos requeridos.",{timeout:8000});
            }
        },
        async sendDataUser() {
            try {
                let formData = new FormData();
                formData.append('pass', this.valuesForm.newPass);
                formData.append('email', this.valuesForm.email);
                formData.append('phone', this.valuesForm.phone);
                if (this.valuesForm.photo != null) {
                    formData.append('photo', this.valuesForm.photo);
                }
                const resp = await axios.post(
                    //'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/api/v2/change-default-password',
                    //'http://localhost/db-service/db-service-oauth-acl/api/v2/change-default-password',
                    'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/api/v2/change-user-info',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'Accept': 'application/json',
                            'Authorization': 'Bearer ' + this.$store.state.token
                        }
                    }
                );
                if (resp.data.status === "OK") {
                    this.$store.state.checkFourMonthPassword = false;
                    this.confirmationDialog = true;
                    if(resp.data.hasOwnProperty('user_info')){
                        if(resp.data.user_info.hasOwnProperty('telefono_movil')){
                            this.$store.state.userInfo.telefono_movil = resp.data.user_info.telefono_movil;
                        }else{this.$store.state.userInfo.telefono_movil = null;}
                        if(resp.data.user_info.hasOwnProperty('correo_personal')){
                            this.$store.state.userInfo.correo_personal = resp.data.user_info.correo_personal;
                        }else{this.$store.state.userInfo.correo_personal = null;}
                        if(resp.data.user_info.hasOwnProperty('foto')){
                            this.$store.state.userInfo.foto = resp.data.user_info.foto;
                        }else{this.$store.state.userInfo.foto = null;}
                    }
                } else {
                    this.$snotify.error(resp.data.status, { timeout: 8000 });
                }
            } catch (error) {
                this.$snotify.error("No fué posible guardar los datos.", { timeout: 8000 });
                //console.error(error);
            } finally {
                this.btnSaveUserInfoLoading = false;
            }
        },
        changeInput(event){
            if(this.newPass.length>5 || this.repeatNewPass.length>5){
                this.showLevel = true;

            }
            else{
                this.showLevel = false;
            }
        },
        changeNewPass(){
            this.showNewPass = !this.showNewPass;
            return this.$refs.refNewPass.focus();
        },
        changeRepeatNewPass(){
            this.showRepeatNewPass = !this.showRepeatNewPass;
            return this.$refs.refRepeatNewPass.focus();
        },
        changeNewFormPass(){
            this.showNewFormPass = !this.showNewFormPass;
            return this.$refs.refNewFormPass.focus();
        },
        changeRepeatNewFormPass(){
            this.showRepeatNewFormPass = !this.showRepeatNewFormPass;
            return this.$refs.refRepeatNewFormPass.focus();
        },
        nextPass(){
            this.$refs.refRepeatNewPass.focus();
        },
        nextRepeatPass(){
            setTimeout(() => {
                this.$refs.refBtnSave.$el.focus();
            })
        },
        nextFormPass(){
            this.$refs.refRepeatNewFormPass.focus();
        },
        nextRepeatFormPass(){
            this.$refs.refEmail.focus();
        },
        nextRepeatFormEmail(){
            this.$refs.refPhone.focus();
        },
        nextRepeatFormPhone(){
            setTimeout(() => {
                this.$refs.refBtnSaveInfo.$el.focus();
            })
        },
        extendSession(){
            this.keyRerender += 1;
            this.showIdleTimer = false;
        },
        endSession(){
            this.isIdle = true;
            localStorage.clear();
        },
        changeIframeByAndSetTab(src){
            this.$store.state.tabDocument=true
            this.$refs.customTabs.showInvisible()
            if(this.$store.state.version == null){
                this.mySrc = src + '?version=' + document.title.substr(document.title.length - 5);
            }
            else{
                this.mySrc = src + '?version=' + this.$store.state.version
            }
        },
        changeIframeBy(src){
            this.$store.state.tabDocument=false
            if(this.$store.state.version == null){
                this.mySrc = src + '?version=' + document.title.substr(document.title.length - 5);
            }
            else{
                this.mySrc = src + '?version=' + this.$store.state.version
            }
        },
        goToHome(){
            this.mySrc = "/home"
            this.currentTab = 0
        },
        reloadPage(){
            if(this.$store.state.version == null){
                window.location = window.location.href+'?version=' + document.title.substr(document.title.length - 5);
            }
            else{
                window.location = window.location.href+'?version=' + this.$store.state.version
            }
        },
        async checkVersionInit(){
            try {
                let ran = Math.floor(Math.random() * (999999 - 1 + 1) + 1);
                let url = "/info/sisep-info";
                //DEV let url = "http://100.0.102.78:8103/sisep-info";
                let resp = await axios.get(url+"?ver="+ran.toString());
                if(resp.data.version !== document.title.substr(document.title.length - 5)){
                    this.alertVersion = true;
                    this.dialogVersion = true;
                    this.$store.state.version = resp.data.version;
                }
                else{
                    this.alertVersion = false
                    this.dialogVersion = false;
                }
                if(resp.data.alerta == true){
                    this.alerta = true;
                    this.mensaje = resp.data.mensaje;
                }
                else{
                    this.alerta = false;
                }
            } catch (error) {
                this.alertVersion = false;
                this.dialogVersion = false;
                this.alerta = false;
            }
        },
        async checkVersion(){
            setInterval(async function(){
                try {
                    let ran = Math.floor(Math.random() * (999999 - 1 + 1) + 1);
                    let url = "/info/sisep-info";
                    //DEV let url = "http://100.0.102.78:8103/sisep-info";
                    let resp = await axios.get(url+"?ver="+ran.toString());
                    if(resp.data.version !== document.title.substr(document.title.length - 5)){
                        this.alertVersion = true;
                        this.dialogVersion = true;
                        this.$store.state.version = resp.data.version;
                    }
                    else{
                        this.alertVersion = false
                        this.dialogVersion = false;
                    }
                    if(resp.data.alerta == true){
                        this.alerta = true;
                        this.mensaje = resp.data.mensaje;
                    }
                    else{
                        this.alerta = false;
                    }
                } catch (error) {
                    this.alertVersion = false;
                    this.dialogVersion = false;
                    this.alerta = false;
                }
            }.bind(this),360000);
        },
        checkHash(){
            if(window.location.hash) {
                var hash = window.location.hash.substring(1);
                console.log("EXIST: " + hash);
                /*switch (window.location.hash) {
                    case '': {break;}
                    default: break;
                }*/
            }
        },
        async verifyPassword(){
            if(this.repeatNewPass != this.newPass){
                this.$snotify.error("Las contraseñas deben coincidir.",{timeout:8000});
            }
            else{
                if(this.repeatNewPass.length>=6){
                    this.saveNewPassword();
                }
                else{
                    this.$snotify.error("Las contraseñas deben tener al menos 6 caracteres.",{timeout:8000});
                }
            }
        },
        async saveNewPassword(){
            try {
                this.loaderBtnSavePassword = true;
                let resp = await axios.post(
                    'https://sisep.minedu.gob.bo/db-service/db-service-oauth-acl/api/v2/change-default-password',
                    {pass:this.newPass},
                    {headers:{'Content-Type':'application/json','Accept':'application/json','Authorization':'Bearer '+this.$store.state.token}}
                );
                if(resp.data.status == "OK"){
                    //this.$snotify.info("CONTRASEÑA MODIFICADA CORRECTAMENTE");
                    this.$store.state.changePasswordDialog = false;
                    this.confirmationDialog = true;
                }
                else{
                    this.$snotify.error(resp.data.status,{timeout:10000});
                    this.loaderBtnSavePassword = false;
                }
            }
            catch (error) {
                this.$snotify.error("No fué posible cambiar su contraseña");
                console.log(error)
                this.loaderBtnSavePassword = false;
            }
        }
    },
    mounted(){
        //this.checkHash();
        this.checkVersionInit();
    },
    async created(){
        await this.$store.dispatch('verificarToken')
        if(this.$store.state.userInfo.correo_personal){
            this.valuesForm.email = this.$store.state.userInfo.correo_personal;
        }else{this.valuesForm.email=''}
        if(this.$store.state.userInfo.telefono_movil){
            this.valuesForm.phone = this.$store.state.userInfo.telefono_movil;
        }else{this.valuesForm.phone=''}
        if(this.$store.state.userInfo.foto){
            this.fotoLabel = 'Cambiar foto (opcional):';
        }else{this.fotoLabel = 'Foto (Opcional):';}
        if(this.$store.state.changePasswordDialog){
            this.$refs.refNewPass.focus();
        }
        if(this.$store.state.checkFourMonthPassword){
            this.$refs.refNewFormPass.focus();
        }
        this.checkVersion();
    }
}
</script>
